import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class AcceptInviteComponent implements OnInit, OnDestroy {
  inviteToken = '';
  therapistName = '';
  clinicCode = '';

  isLoading = false;
  isAccepted = false;
  errorMessage = '';
  countdown = 8;
  private countdownInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.inviteToken = params['token'] ?? '';
      this.decodeToken();
    });
  }

  private decodeToken(): void {
    if (!this.inviteToken) return;
    try {
      const raw = atob(this.inviteToken);
      const parts = raw.split('.');
      if (parts.length < 2) return;
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      this.therapistName = payload['name'] ?? '';
      this.clinicCode = payload['clinicId'] ?? '';
    } catch {
      // Token cannot be decoded — fields stay empty; backend will validate
    }
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  private startRedirectCountdown(): void {
    this.countdown = 8;
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval!);
        this.router.navigate(['/']);
      }
    }, 1000);
  }

  acceptInvite(): void {
    if (!this.inviteToken) {
      this.errorMessage = 'Invalid invite link.';
      return;
    }
    this.isLoading = true;
    this.errorMessage = '';

    this.authService.acceptTherapistInvite(this.inviteToken).pipe(
      finalize(() => { this.isLoading = false; }),
    ).subscribe({
      next: (response: any) => {
        if (response?.data === true) {
          this.isAccepted = true;
          this.startRedirectCountdown();
        } else {
          this.errorMessage = response?.errors?.[0] ?? 'Invite could not be accepted. Please try again.';
        }
      },
      error: (err: Error) => {
        this.errorMessage = err.message || 'An unexpected error occurred. Please try again.';
      },
    });
  }
}
